(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.addEventListener('click', event => {
    const searchButton = event.target.closest('.av-header-search button');
    if (searchButton) {
      const input = searchButton.form.querySelector('input[type="search"]');
      if (!input.value.trim()) { event.preventDefault(); input.focus(); }
    }
    const reviewArrow = event.target.closest('[data-av-review-dir]');
    if (reviewArrow) {
      const track = reviewArrow.closest('.exx-testimonials-slider').querySelector('.exx-testimonials__track');
      const card = track.firstElementChild;
      if (card) track.scrollBy({left:Number(reviewArrow.dataset.avReviewDir)*(card.getBoundingClientRect().width+20),behavior:reduced.matches?'instant':'smooth'});
    }
    const tab = event.target.closest('[data-av-tabs] [role="tab"]');
    if (tab) {
      const section = tab.closest('[data-av-tabs]');
      section.querySelectorAll('[role="tab"]').forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
      });
    }
    const arrow = event.target.closest('[data-av-scroll]');
    if (arrow) {
      const track = arrow.closest('.av-carousel-shell').querySelector('[data-av-track]');
      const card = track.firstElementChild;
      if (card) {
        const behavior = reduced.matches ? 'instant' : 'smooth';
        track.scrollBy({left:Number(arrow.dataset.avScroll)*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior});
      }
    }
    const pause = event.target.closest('[data-av-video-pause]');
    if (pause) {
      const video = pause.closest('.av-film').querySelector('video');
      if (video.paused) video.play().catch(() => {}); else video.pause();
    }
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-av-tabs] [role="tab"]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    event.preventDefault();
    const tabs = [...tab.parentElement.querySelectorAll('[role="tab"]')];
    const index = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[index].click(); tabs[index].focus();
  });
  function init(root = document) {
    root.querySelectorAll('.av-carousel-shell').forEach(shell => {
      const track = shell.querySelector('[data-av-track]');
      const next = shell.querySelector('.av-carousel-next');
      if (!track || !next || track._avCarouselObserver) return;
      const prev = shell.querySelector('.av-carousel-prev');
      const update = () => { const overflow = track.scrollWidth > track.clientWidth + 2; next.hidden = !overflow; next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; if(prev) { prev.hidden = !overflow; prev.disabled = track.scrollLeft <= 2; } };
      track.addEventListener('scroll', update, {passive:true});
      track._avCarouselObserver = new ResizeObserver(update);
      track._avCarouselObserver.observe(track);
      update();
    });
    root.querySelectorAll('.av-film video').forEach(video => {
      const button = video.closest('.av-film').querySelector('[data-av-video-pause]');
      if (!button) return;
      if (video.dataset.avReady) return;
      video.dataset.avReady = 'true';
      const sync = () => { button.textContent = video.paused ? 'Play' : 'Pause'; button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video'); };
      video.addEventListener('play', sync); video.addEventListener('pause', sync);
      if (reduced.matches) {video.autoplay = false; video.pause();} sync();
    });
    const header = document.querySelector('.shopify-section-group-header-group');
    const update = () => {const sections = document.querySelectorAll('.shopify-section-group-header-group'); let height=0;sections.forEach(el=>height+=el.getBoundingClientRect().height);document.documentElement.style.setProperty('--av-header-height',height+'px');};
    if (header && !window.avHeaderObserver) { window.avHeaderObserver = new ResizeObserver(update); document.querySelectorAll('.shopify-section-group-header-group').forEach(el=>window.avHeaderObserver.observe(el)); }
    update();
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-av-track]').forEach(track => track._avCarouselObserver?.disconnect()));
})();
